import axios from "axios";

axios.defaults.headers.timeout = 1000 * 60;
axios.defaults.baseURL = 'http://47.92.208.0:8080';//http://47.92.208.0:8080  http://192.168.2.232:8080

//请求拦截
axios.interceptors.request.use(
  (config) => {
    config.headers = {
      'Content-Type':'application/json',
      'Accept': 'application/json'
    };

    let token = localStorage.getItem('rainToken');
    if(token && token != ''){
      const  token_type="Bearer";
      config.headers['X-Authorization'] = token_type+ ' ' + token;
    }
    // console.log("url",config.baseURL + config.url);
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

//响应拦截
axios.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    console.log(error.response);
    if(error && error.response) {
      switch (error.response.status) {
        case 400:
          error.messgae = '请求错误';
          break;
        case 401:
          error.messgae = '未授权请重新登录';
          window.location.href='#/';
          break;
        case 403:
          error.messgae = '拒绝访问';
          break;
        case 404:
          error.messgae = '请求错误，未找到资源';
          window.location.href = "#/";
          break;
        case 405:
          error.messgae = '请求方法不允许';
          break;
        case 408:
          error.messgae = '请求超时';
          break;
        case 501:
          error.messgae = '网络未实现';
          break;
        case 502:
          error.messgae = '网络错误';
          break;
        case 503:
          error.messgae = '服务不可用';
          break;
        case 504:
          error.messgae = '网络超时';
          break;
        case 505:
          error.messgae = 'http版本不支持该请求';
          break;
        default:
          error.messgae =  `连接错误${error.response.status}`;
      }
    } else {
      if(JSON.stringify(error).includes('timeout')) {
        console.log('服务器响应超时，请刷新当前页');
      }
      error.messgae = '连接服务器失败';
    }
    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/untils/http.js